import React, { Component, useEffect } from "react";
import { Typography, Spin, Button, notification, Modal, Row, Col } from "antd"; // Input, Popover,
// import { SearchOutlined } from "@ant-design/icons";
// import ReadMoreReact from "read-more-react";
import { connect } from "react-redux";
import {
  IoMdTime,
  IoIosCalendar,
  IoMdCart,
  IoIosPaper,
  IoMdSend,
} from "react-icons/io";
import { IoPersonOutline } from "react-icons/io5";

import { ParsedDate } from "../../function/ParseDate";
import { history } from "../../history";
import axiosGlobal from "../../axios-global";
import { getAPIUrl } from "../../configs/global_var";
import ModalLogin from "../../components/modalLogin/index.js";
import Psikogram from "../myApplication/FormDataPdf.jsx";
import clock from "../../assets/img/clock.png";
import avatar from "../../assets/img/avatar.png";
// import { getAPIUrl } from "./configs/global_var.js";

import "../../assets/css/publish.css";
import "../../assets/css/modal.css";
import { throwStatement } from "@babel/types";

const { Text } = Typography;
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      modalLogin: false,
      modalApply: false,
      publish_id: null,
      publish: null,
      institute: null,
      modal: false,
      participantId: null,
      logo: ""
    };
  }

  componentDidMount(){
    // async function fetchData() {
    // setMobileView(colSize);
    // this.setState({logo: this.props.logo})
    // console.log(this.state.logo)
    const lolo = async () => {
      const fetchLogo = await getAPIUrl();
      this.setState({ logo: fetchLogo[0].logo });
      console.log(this.state.logo);
    };
    lolo();
  }



  // checked
  // componentDidMount() {
  //   if (this.props.token === null) {
  //     history.push("/ecommerce/home");
  //     window.location.reload();
  //   }
  //   this.fetchPublish();
  // }

  // checked
  // fetchPublish() {
  //   this.setState({ loading: true });
  //   axiosGlobal().then((axios) => {
  //     axios
  //       .post("/landing/publish/get", { token: this.props.token })
  //       .then((res) => {
  //         console.log(res);
  //         this.setState({ data: res.data.data });
  //       })
  //       .catch((err) => {

  //         // if (err.message === "Network Error") {
  //         //   this.toastError(
  //         //     "Gagal mengambil data lembaga, silahkan periksa koneksi anda"
  //         //   );
  //         // } else {
  //         //   this.toastError(
  //         //     "Gagal mengambil data lembaga, silahkan coba beberapa saat lagi"
  //         //   );
  //         // }

  //       })
  //       .then(() => this.setState({ loading: false }));
  //   });
  // }

  // closeModal = (type) => {
  //   if (type === "login") {
  //     this.setState({ modalLogin: false });
  //   } else if (type === "apply") {
  //     this.setState({ modalApply: false });
  //   }
  // };

  // start = (data) => {
  //   axiosGlobal().then((axios) => {
  //     axios
  //       .post("/paid/checker", {
  //         token: this.props.token,
  //         publishId: data.publish_id,
  //       })
  //       .then(async (res) => {
  //         console.log("di start button");
  //         console.log(res);
  //         const entranceUrl = await getAPIUrl();
  //         const newWindow = window.open(
  //           `${entranceUrl[0].entrance_url}pages/login?email=${data.participantId}&password=${data.password}&ecommerceUrl=${window.location.hostname}`,
  //           "_self",
  //           "noopener,noreferrer"
  //         );
  //         if (newWindow) newWindow.opener = null;
  //       })
  //       .catch((err) => {
  //         if (err.response.status === 401) {
  //           this.openNotification(
  //             "Session Anda telah berakhir, silakan login kembali",
  //             false
  //           );
  //         } else {
  //           this.openNotification(
  //             "Akun anda belum diaktivasi, silahkan hubungi admin",
  //             false
  //           );
  //         }
  //       });
  //   });
  // };

  // psikogram = (data) => {
  //   this.setState({ participantId: data.participantId, modal: true });
  // };

  // apply() {
  //   axiosGlobal().then((axios) => {
  //     axios
  //       .post("/landing/publish/enroll", {
  //         token: this.props.token,
  //         publishId: this.state.publish_id,
  //       })
  //       .then((res) => {
  //         this.openNotification("Berhasil menambahkan data", true);
  //         this.setState({ modalApply: false });
  //       })
  //       .catch((err) => {
  //         if (err.message === "Network Error") {
  //           this.openNotification(
  //             "Gagal mengambil data , silahkan periksa koneksi anda",
  //             true
  //           );
  //         } else {
  //           this.openNotification("Gagal menambahkan data", false);
  //         }
  //       })
  //       .then(() => this.setState({ loading: false }));
  //   });
  // }

  // buttonClickedHandler = () => {
  //   this.setState({ modalLogin: !this.state.modalLogin });
  // };

  // openNotification = (msg, status) => {
  //   console.log(msg);
  //   const args = {
  //     message: msg,
  //     duration: 3,
  //     className: status ? "notif-succes" : "notif-faild",
  //   };
  //   notification.open(args);
  // };
  changeLogo = (newLogo) => {
    console.log(newLogo)
  }

  render() {
    const {
      loading,
    } = this.state;
    return (
      <>
        <main>
          <section>
            {/* {loading ? ( */}
            {/* <Spin className="loading" /> */}
            {/* ) : ( */}
            {/* <> */}
            <Col
              md={{ span: 18, offset: 3 }}
              xs={{ span: 20, offset: 2 }}

            >
              <Row>
                <Col
                  md={{ span: 10, offset: 7 }}
                  xs={{ span: 12, offset: 6 }}
                  
                >
                  <Col style={{ backgroundColor: "lightgrey", borderRadius: "50%", margin: "1rem 24%", width: "200px", height: "200px" }}>
                    <img src={this.state.logo} alt="preview logo" style={{objectFit: "fill", objectPosition: "center", width: "200px", height: "200px", borderRadius: "50%"}} />
                  </Col>
                  <label
                    style={{
                      width: "40%",
                      margin: "1rem 30%",
                      padding: "8px",
                      backgroundColor: "#fc9804",
                      textAlign: "center",
                      color: "white",
                      cursor: "pointer",
                      borderRadius: "8px",
                      border: "2px solid silver",
                      fontSize: "0.9rem",
                      fontFamily: "Poppins",
                    }}
                  >
                    Change logo
                    <input type="file" style={{ display: "none" }} onChange={this.changeLogo} />
                  </label>
                </Col>
              </Row>
            </Col>
            {/* </> */}
            {/* )} */}
          </section>
        </main>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.login.token,
  };
};

export default connect(mapStateToProps, null)(Index);
